import { useSuspenseQuery } from '@tanstack/react-query'
import { apiClient } from '~/shared/api/data-ingestion-api'

export function useDocument({ documentKey }: { documentKey: string }) {
  return useSuspenseQuery({
    ...apiClient.getDocumentDocumentsKeyGetOptions({
      path: {
        key: documentKey,
      },
    }),
    staleTime: 1000 * 60,
  })
}
